import { useCallback, useEffect, useState } from 'react';

import api, { ApiParams } from '../../common/api/api';
import {
  useApiDelete,
  useApiGet,
  useApiPost,
  useApiPut
} from '../../common/api/Api.hooks';
import { apiResolve } from '../../common/api/apiResolve';
import { TaskJiraIssue } from './TaskJiraIssue.interface';

export function useCreateTaskJiraIssue() {
  const { data, isLoading, error, post } =
    useApiPost<TaskJiraIssue>('tasks-jira');
  return {
    createdTaskJiraIssue: data,
    creatingTaskJiraIssue: isLoading,
    createError: error,
    createTaskJiraIssue: post
  };
}

// non-hook implementation
export function findTaskJiraIssues(taskId: number, params: ApiParams = {}) {
  const request = api.get(`tasks-jira/${taskId}`, params);
  const result = apiResolve<TaskJiraIssue[]>(request);
  return { request, result };
}

export function useFindTaskJiraIssue(taskId: number) {
  const { data, isLoading, error, get } = useApiGet<TaskJiraIssue[]>(
    `tasks-jira/${taskId}`
  );
  return {
    taskJiraIssues: data,
    loadingTaskJiraIssue: isLoading,
    findError: error,
    findTaskJiraIssues: get
  };
}

export function useBulkUpdateTaskJiraIssue() {
  const { data, isLoading, error, put } = useApiPut(`tasks-jira`);
  return {
    updatedTaskJiraIssues: data,
    updatingTaskJiraIssue: isLoading,
    updateError: error,
    updateTaskJiraIssues: put
  };
}

export function useDeleteTaskJiraIssue() {
  const [path, setPath] = useState('');
  const { data, isLoading, error, del } = useApiDelete(path);
  useEffect(() => {
    if (path) del();
  }, [path, del]);
  const deleteTaskJiraIssue = useCallback((id: number) => {
    setPath(`tasks-jira/${id}`);
  }, []);
  return {
    deletedJiraIssue: data,
    deletingTaskJiraIssue: isLoading,
    deleteError: error,
    deleteTaskJiraIssue
  };
}
